const config = {
  CLIENT_ID: "MAGELLAN-CORE-SERIES-2023",
  URL_CONFIG: "https://events-public-assets.s3-ap-southeast-2.amazonaws.com/events/mfgcoreseries2023/config/index.json?v=20210622-1",
  BITMOVIN_ANALYTICS_KEY: "ade734cd-842a-4308-b630-9d3c3b709ce0",
  MUX_ANALYTICS_KEY: "g390j6uqqi612ienbuk94q10h",
  S3_REGION: "ap-southeast-2",
  S3_BUCKET: "events-public-assets",
  COGNITO_REGION: "ap-southeast-2",
  COGNITO_USER_POOL_ID: "ap-southeast-2_9974pNMJ4",
  COGNITO_APP_CLIENT_ID: "3qqda24k281vs1jgo3aqo89vlo",
  COGNITO_IDENTITY_POOL_ID: "ap-southeast-2:6642ee5c-e1aa-4bfa-8386-2a024fbee44f",
  BACKEND_REGION: "ap-southeast-2",
  BACKEND_URL: "https://x6tm1s363a.execute-api.ap-southeast-2.amazonaws.com/magellan",
  BACKEND_API_NAME: "backend-api",
  ZENDESK_API_TOKEN: "42pzgqiuUL6qTOtljOIJWcELj2lJN3qA9ADBL9Ig",
};

export default config;
